import {
  defaultFilters,
  searchFilterKeys,
  RawNonFilterParams,
  RawSearchFilters,
  SearchFilterKeys,
  SearchFiltersStateFilters,
} from '@cinch-nx/data-search'
import { getDefaultNonFilterParams } from '..'

export function convertRawSearchFiltersToSearchFilters(
  raw: RawSearchFilters & RawNonFilterParams,
  allCinchStores: string[],
  shouldShowFinanceTypeFilter?: boolean,
  shouldUseDataDrivenSortOrderAsDefault?: boolean,
): SearchFiltersStateFilters {
  const defaultNonFilterParams = getDefaultNonFilterParams(
    shouldUseDataDrivenSortOrderAsDefault,
  )
  const parsedEntries = Object.fromEntries(
    Object.entries(raw).map(([key, value]) => {
      // when store=all-stores in the URL, filter on all possible individual store names
      if (key === 'store' && value === 'all-stores') {
        return [key, allCinchStores]
      } else if (searchFilterKeys.includes(key as SearchFilterKeys)) {
        return [key, value.split(',')]
      } else if (key === 'useMonthly') {
        return [key, value === 'true']
      } else {
        return [key, Number.parseInt(value)]
      }
    }),
  )
  // this allows us to support both useMonthly and financeType in the URL. if useMonthly=true is in the response and the FF is true, remove
  // useMonthly from params and replace it with financeType=any
  return shouldShowFinanceTypeFilter && parsedEntries.useMonthly
    ? {
        ...defaultFilters,
        ...defaultNonFilterParams,
        ...parsedEntries,
        useMonthly: false,
        financeType: ['any'],
      }
    : {
        ...defaultFilters,
        ...defaultNonFilterParams,
        ...parsedEntries,
      }
}
